module.exports = __webpack_public_path__ + "static/media/404.2f263b07.svg";